import { useMemo, useState } from 'react';
import { message } from 'antd';
import { useMutation } from '@apollo/client';
import { SEARCH_INDEX_DELAY } from '../../consts';
import DELETE_COURSE_MUTATION from '../mutations/DELETE_COURSE_MUTATION';
  
const useDeleteCourse = () => {
    const [ isDeleting, setIsDeleting ] = useState( false );
    const [ deleteMutation ] = useMutation( DELETE_COURSE_MUTATION );

    const handleDelete = async ( id, onFinishCallback ) => {
        setIsDeleting( true );
        
        try {
            await deleteMutation( { variables: { courseID: id } } );

            setTimeout( () => {
                if ( onFinishCallback ) { onFinishCallback(); }
                setIsDeleting( false );
            }, SEARCH_INDEX_DELAY );
        } catch ( e ) { 
            console.error( e ); 
            message.error( 'Error deleting Course!' );
            setIsDeleting( false );
        }
    };

    return useMemo( () => {
        return {
            isDeleting,
            deleteCourse: handleDelete
        };
    }, [ isDeleting ] );
};

export default useDeleteCourse;
